/**
 * This module stubs out network state utilities for the web because expo no
 * longer supports webpack (so we can't use expo-network on the web). We don't
 * have any offline features for the web yet so this doesn't really matter. On
 * the web the network state will always be "unknown".
 */

export enum NetworkStateType {
  UNKNOWN = "UNKNOWN",
}

export type NetworkState = typeof DEFAULT_STATE

const DEFAULT_STATE = {
  type: NetworkStateType.UNKNOWN,
  isConnected: undefined,
  isInternetReachable: undefined,
}

export const networkStateNotEqual = (
  a: NetworkState,
  b: NetworkState,
): boolean =>
  a.type !== b.type ||
  a.isConnected !== b.isConnected ||
  a.isInternetReachable !== b.isInternetReachable

export const isOfflineState = (state: NetworkState): boolean =>
  state.isInternetReachable === false

export async function getNetworkState(
  _params: { staleTime?: number } = {},
): Promise<NetworkState> {
  return DEFAULT_STATE
}

export function getCachedNetworkState(): NetworkState {
  return DEFAULT_STATE
}

export function addNetworkStateListener(
  _listener: (state: NetworkState) => void,
): () => void {
  return () => {}
}
